// @flow
import WizzeeLog from '../../lib/wizzeeLog';
export type SimResourceType = {|
  type: 'eSIM' | 'STANDARD_SIM',
  resourceSerialNumber: string,
|};

export type EsimProductActionType =
  | {|
      type: 'FETCH_AVAILABLE_SIM',
      payload: {|
        simType: 'eSIM' | 'STANDARD_SIM',
        resourceSerialNumber?: string,
      |},
    |}
  | {|
      type: 'FETCH_AVAILABLE_SIM_SUCCESS',
      payload: {|
        simResource: SimResourceType,
      |},
    |}
  | {|
      type: 'FETCH_AVAILABLE_SIM_FAILURE',
      payload: {|
        error: any,
      |},
    |}
  | {|
      type: 'SET_SIM_RESOURCE',
      payload: {|
        simResource: SimResourceType,
      |},
    |}
  | {|
      type: 'SIGNUP_INSTALL_ESIM',
    |}
  | {|
      type: 'GET_ESIM_PRODUCT_PRICE',
    |}
  | {|
      type: 'GET_ESIM_PRODUCT_PRICE_SUCCESS',
      payload: {|
        price: number,
      |},
    |}
  | {|
      type: 'GET_ESIM_PRODUCT_PRICE_FAILURE',
      payload: {|
        error: any,
      |},
    |}
  | {|
      type: 'GET_CHOOSE_ESIM_ROUTENAME',
    |}
  | {|
      type: 'SET_ESIM_COMPATIBLE',
    |}
  | {|
      type: 'ESIM_SELECTED',
    |}
  | {|
      type: 'ESIM_SELECTED_SUCCESS',
    |}
  | {|
      type: 'GET_CHOOSE_ESIM_ROUTENAME_SUCCESS',
      payload: {|
        chooseEsimRouteName: any,
      |},
    |}
  | {|
      type: 'GET_CHOOSE_ESIM_ROUTENAME_FAILURE',
      payload: {|
        error: any,
      |},
    |};

export function fetchAvailableSim(
  simType: 'eSIM' | 'STANDARD_SIM' = 'eSIM',
  resourceSerialNumber?: string,
): EsimProductActionType {
  return {
    type: 'FETCH_AVAILABLE_SIM',
    payload: {
      simType,
      resourceSerialNumber,
    },
  };
}

export function fetchAvailableSimFailure(
  error: any,
): EsimProductActionType {
  return {
    type: 'FETCH_AVAILABLE_SIM_FAILURE',
    payload: {
      error,
    },
  };
}

export function fetchAvailableSimSuccess(
  simResource: SimResourceType,
): EsimProductActionType {
  return {
    type: 'FETCH_AVAILABLE_SIM_SUCCESS',
    payload: {
      simResource,
    },
  };
}

export function setSimResource(
  simResource: SimResourceType,
): EsimProductActionType {
  return {
    type: 'SET_SIM_RESOURCE',
    payload: {
      simResource,
    },
  };
}

export function installESim(): EsimProductActionType {
  return {
    type: 'SIGNUP_INSTALL_ESIM',
  };
}

export function getESimProductPrice(): EsimProductActionType {
  return {
    type: 'GET_ESIM_PRODUCT_PRICE',
  };
}

export function getESimProductPriceSuccess(
  price: number,
): EsimProductActionType {
  return {
    type: 'GET_ESIM_PRODUCT_PRICE_SUCCESS',
    payload: {
      price,
    },
  };
}

export function getESimProductPriceFailure(error: any): EsimProductActionType {
  return {
    type: 'GET_ESIM_PRODUCT_PRICE_FAILURE',
    payload: {
      error,
    },
  };
}

export function getChooseEsimRouteNameSuccess(
  chooseEsimRouteName: string,
): EsimProductActionType {
  return {
    type: 'GET_CHOOSE_ESIM_ROUTENAME_SUCCESS',
    payload: {
      chooseEsimRouteName,
    },
  };
}

export function getChooseEsimRouteNameFailure(
  error: any,
): EsimProductActionType {
  return {
    type: 'GET_CHOOSE_ESIM_ROUTENAME_FAILURE',
    payload: {
      error,
    },
  };
}

export function getChooseEsimRouteName(): EsimProductActionType {
  return {
    type: 'GET_CHOOSE_ESIM_ROUTENAME',
  };
}

export function setIsEsimCompatible(
  isEsimCompatible: boolean,
): EsimProductActionType {
  return {
    type: 'SET_ESIM_COMPATIBLE',
    payload: {
      isEsimCompatible,
    },
  };
}

export function eSimSelectedSuccess(
  eSimSelected: boolean,
): EsimProductActionType {
  WizzeeLog.log('>>> eSimSelectedSuccess() - selected', eSimSelected);
  return {
    type: 'ESIM_SELECTED_SUCCESS',
    payload: {
      eSimSelected,
    },
  };
}
